import { render, staticRenderFns } from "./List-shipment-COD-branch.vue?vue&type=template&id=151c6132&scoped=true"
import script from "./List-shipment-COD-branch.vue?vue&type=script&lang=js"
export * from "./List-shipment-COD-branch.vue?vue&type=script&lang=js"
import style0 from "./List-shipment-COD-branch.vue?vue&type=style&index=0&id=151c6132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c6132",
  null
  
)

export default component.exports